<template>
  <div class="teacher-account" v-loading="loading">
    <div v-if="showDetail">
      <el-row>
        <el-button type="text" size="medium" @click="closeDetail()">返回</el-button>
      </el-row>
      <profileView :teacherId="selectedTeacherOrAssistantId" ></profileView>
    </div>
    <div v-if="!showDetail">
      <el-row class="grid-content">
        <el-col class="text-right">
          <el-checkbox v-model="showInactive" @change="onShowInactiveChange">显示离职人员</el-checkbox>
          <el-button @click="showAdd()" type="primary" class="add-teacher-btn margin-left-10" icon="el-icon-plus"
            size="medium">
            添加{{this.role == 1 ?  "老师" : "助教"}}
          </el-button>
          <el-input placeholder="搜索名字" size="medium" clearable suffix-icon="el-icon-search" class="margin-left-10 search-InputBox"
            v-model.trim="searchCondition.TeacherName" @change="onSearchConditionChanged"
            @keyup.enter.native="onSearchConditionChanged"> </el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-table ref="accountsTable" :data="accountList" :cell-class-name="cellStyle"
          :header-row-class-name="'el-table-header'" :height="620">
          <el-table-column prop="TeacherName" label="姓名" sortable fixed>
            <template slot-scope="scope">
              <div>
                <span v-bind:class="{'leave-job': scope.row.WorkStatus=='1'}" class="cs-teacherList-Name"
                  @click="showProfile(scope.row.Id)">{{scope.row.TeacherName}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :key="item.IdValue" v-for="item in universityGroups" :property="item.NameValue" :label="item.NameValue"
           :width="120" sortable>
            <template slot-scope="scope">
              <div v-bind:class="{'leave-job': scope.row.WorkStatus=='1'}" :key="index"
                v-for="(course,index) in getCourseList(scope.row[item.NameValue])">
                <span>{{course}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="TrainingCategoryName" label="职业培训" sortable>
            <template slot-scope="scope">
              <div v-bind:class="{'leave-job': scope.row.WorkStatus=='1'}" :key="index"
                v-for="(course,index) in getCourseList(scope.row.TrainingCategoryName)">
                <span>{{course}}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="EnglishTrainingName" label="应试英语" sortable>
            <template slot-scope="scope">
              <div v-bind:class="{'leave-job': scope.row.WorkStatus=='1'}" :key="index"
                v-for="(course,index) in getCourseList(scope.row.EnglishCategoryName)">
                <span>{{course}}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="WorkStatus" label="在职状态" sortable>
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.WorkStatus=='0'">
                  <el-button class="job-icon on-job-icon" size="mini" type="success">在职</el-button>
                </span>
                <span v-if="scope.row.WorkStatus=='1'">
                  <el-button class="job-icon leave-job-icon" size="mini" type="success">离职</el-button>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="Id" label="">
            <template slot-scope="scope">
              <div>
                <el-button type="primary" size="mini" @click="showEditCourse(scope.row.Id)"
                  :disabled="scope.row.WorkStatus=='1'">
                  编辑课程
                </el-button>
                <el-button type="primary" size="mini" @click="showEditTeacher(scope.row.Id)">
                  编辑账号
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <el-dialog :close-on-click-modal="false" width="700px" :visible.sync="addDialogVisible" top="8vh">
        <addEditView :dialogVisible="addDialogVisible" :teacherId="selectedTeacherOrAssistantId" :isAdded="isAdded" :role="role"
          @closeDialog="closeDialog()" @refreshData="loadCourseList()" ></addEditView>
      </el-dialog>

      <el-dialog :close-on-click-modal="false" width="700px" :visible.sync="editCourseVisible" top="8vh">
        <coursesView :dialogVisible="editCourseVisible" :teacherId="selectedTeacherOrAssistantId"
          @closeDialog="closeCourseDialog()" @refreshData="loadCourseList()" ></coursesView>
      </el-dialog>
    </div>
  </div>

</template>

<style lang="scss" scoped>
.teacher-account {
  .grid-content {
    .cs-schedule-buttonContainer {
      text-align: right;
    }
    margin-bottom: 10px;
  }
  .cs-teacherList-Name {
    color: #409eff;
    cursor: pointer;
  }
  .gray {
    color: gray;
  }
  .margin-left-10 {
    margin-left: 10px;
  }
  .search-InputBox {
    width: 200px;
  }
  .error-message {
    width: 300px;
    height: 20px;
  }
  .leave-job {
    color: #b2b2b2;
  }
  .job-icon {
    padding: 5px;
    padding-left: 7px;
    padding-right: 7px;
    cursor: default;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .on-job-icon {
    background-color: #2ab893;
    border-color: #2ab893;
  }
  .leave-job-icon {
    background-color: #b2b2b2;
    border-color: #b2b2b2;
  }
  .add-teacher-btn {
    background-color: #59c2e6 !important;
    border-color: #59c2e6 !important;
  }
}
</style>

<script>
import { getUniversityGroups } from "../../service/common.service";
import { getTeacherAccountCourseList } from "../../service/teacherCourse.service";
import addEditView from "./teacherAddEdit";
import coursesView from "./teacherCourse";
import profileView from "./teacherProfile";

export default {
  props: {
    isActive: Boolean,
    role: Number
  },
  data() {
    return {
      loading: false,
      allTeacherAccountList: [],
      accountList: [],
      universityGroups: [],
      searchCondition: {},
      addDialogVisible: false,
      isAdded: true,
      selectedTeacherOrAssistantId: -1,
      editCourseVisible: false,
      showDetail: false,
      showInactive: false,
      isLoadedData: false
    };
  },
  mounted() {
    this.loadUniversityGroups();
    //this.loadCourseList();
  },
  components: {
    coursesView,
    addEditView,
    profileView,
  },
  created(){
    if (this.isActive && !this.isLoadedData) {
      this.loadCourseList();
      
    }
  },
  methods: {
    onShowInactiveChange() {
      this.getTeacherAccountList();
    },
    refreshAccountList(){
      this.$refs.accountsTable.doLayout();
    },
    getTeacherAccountList() {
      
      if (this.showInactive) {
        this.accountList = this.allTeacherAccountList;
      } else {
        this.accountList = this.allTeacherAccountList.filter(
          (i) => i.WorkStatus == 0
        );
      }
      this.$nextTick(()=>{
        setTimeout(() => {
          this.refreshAccountList();
        }, 500);
        
      })
    },
    loadCourseList() {
      this.loading = true;
      getTeacherAccountCourseList(this.searchCondition.TeacherName, this.role).then(
        (result) => {
          if (!!result && result.success) {
            if (!!result.data) {
              this.allTeacherAccountList = result.data;
            } else {
              this.allTeacherAccountList = [];
            }
            this.getTeacherAccountList();
            this.loading = false;
            this.isLoadedData = true;
          }
        }
      );
    },
    loadUniversityGroups() {
      getUniversityGroups(false, true).then((result) => {
        if (!!result && result.success) {
          this.universityGroups = result.data.filter(
            (i) => i.NameValue != "无学校"
          );
          if (this.universityGroups && this.universityGroups.length > 0) {
            this.universityGroups.forEach((r) => {
              r.NameValue = r.NameValue.replace(new RegExp("&", "gm"), "/");
            });
          }
        }
      });
    },
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    getCourseList(courseStr) {
      if (courseStr && courseStr.length > 0) {
        return courseStr.split("|");
      }
      return ["--"];
    },
    onSearchConditionChanged() {
      this.loadCourseList();
    },
    showAdd() {
      this.isAdded = true;
      this.selectedTeacherOrAssistantId = -1;
      this.addDialogVisible = true;
    },
    showEditTeacher(id) {
      this.isAdded = false;
      this.selectedTeacherOrAssistantId = id;
      this.addDialogVisible = true;
    },
    closeDialog() {
      this.addDialogVisible = false;
    },
    closeDetail() {
      this.showDetail = false;
    },
    showEditCourse(id) {
      this.selectedTeacherOrAssistantId = id;
      this.editCourseVisible = true;
    },
    closeCourseDialog() {
      this.editCourseVisible = false;
    },
    showProfile(id) {
      this.showDetail = true;
      this.selectedTeacherOrAssistantId = id;
    },
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
          this.loadCourseList();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/teacherAccount/teacherAndAssistantAccount.vue